<div class="container-fluid">
  <app-content-tab-list activeTab="0" type="user" category="User Management"></app-content-tab-list>
  <div class="row section1 justify-content-between align-items-center mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">User Information</h5>
        <p class="home-subtitle">List of all users</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <div class="dashboard-btn dashboard-manage">
        <div><a routerLink="/users/create-user">
          <button class="btn btn-primary btn-dashboard mt-2"><i class="las la-plus"></i>Create new user</button>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="users-filters-card">
      <div class="users-filters-title">Filter Users</div>
      <div class="users-filters-grid">
        <div class="users-filter-item users-filter-item-wide">
          <label class="users-filter-label">Keyword</label>
          <input type="text"
            class="form-control"
            [(ngModel)]="filters.keyword"
            (keydown)="handleFilterInputKeyDown($event)"
            placeholder="Name, username, email or user id"/>
        </div>

        <div class="users-filter-item">
          <label class="users-filter-label">Type</label>
          <select class="form-control" [(ngModel)]="filters.type">
            <option value="all">All</option>
            <option value="Bhakt">Bhakt</option>
            <option value="Vishwaguru">Vishwaguru</option>
          </select>
        </div>

        <div class="users-filter-item">
          <label class="users-filter-label">Approval</label>
          <select class="form-control" [(ngModel)]="filters.approved">
            <option value="all">All</option>
            <option value="approved">Approved</option>
            <option value="pending">Pending</option>
          </select>
        </div>

        <div class="users-filter-item">
          <label class="users-filter-label">Status</label>
          <select class="form-control" [(ngModel)]="filters.status">
            <option value="all">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div class="users-filter-item">
          <label class="users-filter-label">Sort By</label>
          <select class="form-control" [(ngModel)]="filters.sortBy">
            <option value="created_desc">Latest created</option>
            <option value="created_asc">Oldest created</option>
            <option value="name_asc">Name (A-Z)</option>
            <option value="name_desc">Name (Z-A)</option>
          </select>
        </div>

        <div class="users-filter-actions">
          <button class="btn users-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
          @if (hasActiveFilters()) {
            <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      @if (users) {
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Image</th>
              <th scope="col">Full Name</th>
              <th scope="col">Email address</th>
              <th class="text-nowrap" scope="col">Claimed ?</th>
              <th class="text-nowrap" scope="col">Approved ?</th>
              <th class="text-nowrap" scope="col">Active ?</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!loading && !!users.users?.length) {
            <tbody>
              @for (u of users.users | paginate: {itemsPerPage: perPage, currentPage: users.currentPage, totalItems: users.totalItems}; track u) {
                <tr
                  >
                  <td class="text-nowrap" [attr.title]="(u.id || '').toUpperCase()"><span>{{(u.id || '').slice(-6).toUpperCase()}}</span>
                  <i (click)="handleCopyToClipboard(u.id);" class="las la-copy la-lg pointer copy-icon"></i>
                </td>
                <td><img src="{{u.profile}}" class="rounded-circle" width="40" height="40"
                onerror="this.src='assets/images/user_avatar.png'" alt=""></td>
                <td>{{u.firstName ? (u.firstName + ' ' + (u.lastName ? u.lastName : '')) : 'N/A'}}</td>
                <td>{{u.email}}</td>
                <td [ngClass]="u.profile_claim ? 'text-success' : 'text-danger'">{{ u.profile_claim ? 'Yes' : 'No' }}</td>
                <td
                [ngClass]="u.approvedByAdmin ? 'text-success' : 'text-danger'">{{ u.approvedByAdmin ? 'Yes' : 'No' }}</td>
                <td
                [ngClass]="u.status !== 'inactive' ? 'text-success' : 'text-danger'">{{ u.status === 'inactive' ? 'No' : 'Yes' }}</td>
                <td>{{u.createdAt | date : 'medium'}}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="   mr-3 text-primary py-2 text-nowrap" >
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap" [routerLink]="['/users/details/', u.id]">
                          <i class="las la-eye mb-1 la-lg   align-middle mr-0"></i> View</a>
                          <a class=" dropdown-item  text-info border-bottom py-2 text-nowrap" [routerLink]="['/users/edit-details/', u.id]">
                            <i class="las la-edit mb-1 la-lg  align-middle mr-0"></i> Edit</a>
                            @if (!u.approvedByAdmin) {
                              <a
                                (click)="approveUser(u.id)"
                                class=" dropdown-item  text-success border-bottom py-2 text-nowrap">
                                <i class="las la-check mb-1 la-lg  align-middle mr-0"></i> Approve</a>
                              }
                              @if (u.status === 'inactive') {
                                <a
                                  (click)="activateUser(u.id)"
                                  class=" dropdown-item  text-success border-bottom py-2 text-nowrap">
                                  <i class="las la-check mb-1 la-lg  align-middle mr-0"></i> Activate</a>
                                }
                                <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap " [routerLink]="['/users/review-user/', u.id]">
                                  <i class="las la-comment mb-1 la-lg  align-middle mr-0"></i> Reviews</a>
                                  <a class=" dropdown-item text-danger py-2 text-nowrap "
                                    (click)="remove(u)">
                                    <i class="las la-trash mb-1 la-lg  align-middle mr-0"></i> Delete</a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      }
                      @if (loading) {
                        <tbody>
                          @for (q of loaders; track q; let qi = $index) {
                            <tr class="client">
                              <td>
                                <ngx-skeleton-loader [theme]="{width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader
                                [theme]="{ width:'40px',height:'40px', marginBottom: '0px', borderRadius: '50%'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader [theme]="{ width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                              <td>
                                <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                              </td>
                            </tr>
                          }
                        </tbody>
                      }
                    </table>
                  }
                  @if (!loading && !users.users?.length) {
                    <div class="d-flex align-items-center justify-content-center py-5">
                      No users found
                    </div>
                  }
                  <div class="float-right mt-3">
                    <pagination-controls (pageChange)="pageChange($event)"></pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
